import { cn } from "@/lib/utils";

type MarkdownContentProps = {
	contentHtml: string;
	className?: string;
};

export default function MarkdownContent({
	contentHtml,
	className,
}: MarkdownContentProps) {
	return (
		<div
			className={cn(
				"prose prose-neutral dark:prose-invert mx-auto w-full max-w-none min-w-0 break-words",
				"prose-a:underline-offset-4 prose-code:before:content-none prose-code:after:content-none",
				"[&_:not(pre)>code]:rounded [&_:not(pre)>code]:bg-muted [&_:not(pre)>code]:px-1 [&_:not(pre)>code]:break-words [&_:not(pre)>code]:whitespace-pre-wrap",
				"prose-pre:max-w-full prose-pre:overflow-x-auto prose-pre:whitespace-pre prose-pre:break-normal [&_pre_code]:whitespace-pre [&_pre_code]:break-normal",
				"prose-img:rounded-lg prose-img:border",
				className,
			)}
			dangerouslySetInnerHTML={{ __html: contentHtml }}
		/>
	);
}
